"use client";

import { NewsItem } from "./NewsItem";
import type { NewsSectionProps } from "./types";
import { ROUTER_PATH } from "@/src/config";
import React from "react";
import { cn } from "utils";
import log from "logbeacon";
import { useShellRouter } from "@/src/hooks";

/**
 * 新闻区块组件 - 用于显示新闻列表
 */
export const NewsSection: React.FC<NewsSectionProps> = ({
  title,
  news,
  viewAllText = "View all",
  onViewAll,
  className,
  showAll = false,
  onClose,
}) => {
  const router = useShellRouter();
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <h3
        aria-label="News Section h3"
        data-openreplay-label="News Section h3 Semantic"
        id="sem-news-section-h3"
        className="title_s text-content_tertiary"
      >
        {title}
      </h3>
      <div className="flex flex-col gap-4">
        {(showAll ? news : news.slice(0, 4)).map((newsItem, index) => (
          <NewsItem
            data-openreplay-label="SearchResult · NewsSection · NewsItem"
            key={newsItem.id || `news-${index}`}
            news={newsItem}
            onClick={() => {
              if (!newsItem?.source_link) {
                return;
              }
              // 新闻点击逻辑
              try {
                router.push(
                  `${ROUTER_PATH.NEWS_TITLE_DETAIL}/${encodeURIComponent(newsItem.source_link)}`,
                );
              } catch (error) {
                log.error("[NewsSection] link error: ", error);
              }
              onClose?.();
            }}
          />
        ))}
        {onViewAll && (
          <button
            aria-label="News Section"
            data-openreplay-label={`News Section Button | ${viewAllText}`}
            id="btn-news-section"
            className="body_medium_s text-content_brand_primary text-center cursor-pointer hover:opacity-80 transition-opacity w-fit"
            onClick={onViewAll}
          >
            {viewAllText}
          </button>
        )}
      </div>
    </div>
  );
};
